export const selectPublicDTE = (state: IGlobalState): IPublicDocumentDTO =>
  state.publicInvoices.dte
